import React from "react"
import { Modal } from "@mimber/ui-web"
import { CreateOrganizationForm } from "@/components/forms/CreateOrganizationForm"
import type { CreateOrganizationModalProps } from "./CreateOrganizationModal.types"

/**
 * Modal component for creating new organizations
 * Uses the ui-web Modal wrapper with render props pattern
 */
export const CreateOrganizationModal: React.FunctionComponent<
  CreateOrganizationModalProps
> = ({ onSuccess, ...modalProps }) => {
  return (
    <Modal footer={null} title="Create Organization" {...modalProps}>
      {(close) => (
        <CreateOrganizationForm
          onSuccess={(organization) => {
            close()
            onSuccess?.(organization)
          }}
        />
      )}
    </Modal>
  )
}
